<template>
  <BaseModal
    :open="show"
    title="Ketentuan Privasi Akun"
    size="lg"
    @close="$emit('Saya Mengerti')"
  >
    <div class="space-y-4 text-justify">
      <h1
        ref="agenda-preview-title"
        class="mb-4 text-xl font-medium leading-8 text-green-700 font-roboto"
        data-cy="agenda-preview__title"
      >
        Pelajari Lebih Lanjut Tentang Akun Anda
      </h1>
      <p>Akun Administrator adalah akun dengan hak akses lebih luas dibanding kontributor. Digunakan untuk mengelola sistem, anggota, dan konten secara menyeluruh.</p>
      <ul class="list-disc list-inside space-y-2">
        Dengan akun ini, anda dapat: <br>
        <li>Mengelola pengguna: menambah, mengubah, atau mencabut hak akses anggota</li>
        <li>Mengelola konten: membuat, mengedit, mempublikasikan, dan menghapus konten tanpa persetujuan tambahan</li>
        <li>Mengatur sistem: mengelola kategori, pengaturan module, serta fitur dalam Portal Jabar</li>
        <li>Memantau aktifitas: memastikan kualitas, keamanan, dan kepatuhan data/konten</li>
      </ul>
      <ul class="list-disc list-inside space-y-2">
        Namun, akun Administrator memiliki batasan: <br>
        <li>Tidak dapat mengubah atau mencabut hak akses Super Administrator</li>
        <li>Tetap wajib mematuhi kewajiban privasi dan keamanan data Portal Jabar</li>
      </ul>
    </div>
    <template #footer>
      <div class="w-full h-full flex items-center justify-center">
        <BaseButton
          class="h-[38px] px-4 flex items-center rounded-lg border whitespace-nowrap font-bold disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-600 disabled:border-gray-300 bg-green-700 hover:bg-green-600 text-sm text-white"
          data-cy="modal-footer__close-button"
          @click="$emit('close')"
        >
          Saya Mengerti
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/common/components/BaseModal';
import BaseButton from '@/common/components/BaseButton';

export default {
  name: 'PreviewYourAccount',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
